<template>
  <VSelect variant="outlined" color="primary" :bg-color="$vuetify.theme.current.colors.surface" density="comfortable" v-bind="$attrs">
    <template v-for="(x, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </VSelect>
</template>
